import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteService {

    selected$ = new BehaviorSubject(null);
    selectedValue$ = this.selected$.asObservable();
    content:any;


  constructor() { }

   set_autocomplete(id_formfield, id_autocomplete_div, result_list,start_at_letters=3) {
    let input = document.getElementById(id_formfield) as HTMLInputElement;
    let autocomplete_div = document.getElementById(id_autocomplete_div) ;
    input.onkeyup = () =>{
      
        var characters = input.value;
        if (characters.length>=start_at_letters) {
            var res = this.autocomplete(result_list, characters);
            this.renderResults(res, characters, autocomplete_div, input);
            autocomplete_div.classList.remove('invisible');
        }
        else {
            autocomplete_div.classList.add("invisible");
            // delete all childs from result list
            while (autocomplete_div.firstChild) {
                autocomplete_div.removeChild(autocomplete_div.firstChild);
            }
        }
    };
}


 autocomplete(item_list, search_string) {
   
    let results = [];
    item_list.filter( (item) => {
        
        if (item.toLowerCase().includes(search_string.toLowerCase())) {
            
            results.push(item);
        };
    });
    return results
}

 renderResults(results, search, container, form_id) {
   
    // delete unordered list from previous search result
    while (container.firstChild) {
        container.removeChild(container.firstChild);
    }
    // get properties from input field
    let form_font = window.getComputedStyle(form_id, null).getPropertyValue('font-size');
    let form_width = form_id.offsetWidth;

    //set result list to same width less borders
    container.style.width = form_width.toString() + 'px';
    
    if (results.length>0) {
        // create ul and set classes
        let ul = document.createElement('UL');
        ul.classList.add('list-group', 'mt-1');

        // create list of results and append to ul
        // if (results.length>max_results) {
        //     results = results.slice(0, max_results);
        // }
        results.map((item) => {
                let a = document.createElement('li');
                a.classList.add('autocomplete-result', 'list-group-item', 'p-1'); // autocomplete used for init click event, other classes are from bootstrap
                a.setAttribute("reference", form_id.id); // used for click-Event to fill the form
                a.style.fontSize = form_font;
               
                // a.href = '#';
               // a.setAttribute('', ngmodal )
                // see function below - marked search string in results
                a.innerHTML = this.colored_result(item, search);

                // add Eventlistener for search renderResults
                a.addEventListener("click", (event) => {
                    event.preventDefault();
                    event.stopPropagation();
            
                    // get text from list item and set it into reffered form field
                    let content = a.innerText;
                   
                    let form_id = a.getAttribute('reference');
                    
                    (document.getElementById(form_id) as HTMLInputElement).value = content;
                    this.selectedValue (content);

                    // after choosen a result make div with results invisible -> after changing input content again,
                    // all of childs of current div will be deleted [line 48,49]
                    container.classList.add('invisible');
            
                });
                ul.append(a);
        });

        // append ul to container and make container visible
        container.append(ul);
        container.classList.remove('invisible');
        //choose_result(); // add Eventlistener to every result in ul
    }
    else {
        container.classList.add('invisible');

    }
}

// create span's with colored marked search strings
 colored_result(string, search) {
   
    let splitted = string.toLowerCase().split(search.toLowerCase());

    let sp = []; // array of all spans, created in folling loop
    let start = 0; //start for slicing

    splitted.map((element, index) => {
        // empty string at the beginning
        if (element == false) {
            sp.push("<span class='text-info'>" + string.slice(start, start + search.length) + "</span>");
            start = start + search.length;
        }
        else if (index +1 == splitted.length) {
            sp.push("<span>" + string.slice(start, start + element.length) + "</span>");
    }
        else {
            sp.push("<span>" + string.slice(start, start + element.length) + "</span>");
            start = start + element.length;
            sp.push("<span class='text-info'>" + string.slice(start , start + search.length) + "</span>");
            start = start  + search.length;
        }
        });
        
    return sp.join('')
}
 
selectedValue(sl:any){
       this.selected$.next(sl);
     }
 
}
